import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class ApiKeyProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'api-keys'

  getByCompanyId() {
    return this.submit('get', `/${this.endpoint}`)
  }
}
